import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star, ArrowUpRight } from "lucide-react";

const ProductCard = ({ product, index = 0 }) => {
  const from = Math.min(...product.variants.map((v) => v.price));
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="group block overflow-hidden rounded-sm border border-[#27272A] bg-[#0E0E11] transition-all duration-300 hover:-translate-y-1 hover:border-[#EA580C]"
      >
        <div className="relative aspect-square overflow-hidden bg-[#18181B]">
          <img
            src={product.images[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105"
          />
          {product.badge && (
            <span className="absolute left-3 top-3 rounded-sm bg-primary px-2 py-1 font-mono text-[10px] font-bold uppercase tracking-wider text-[#09090B]">
              {product.badge}
            </span>
          )}
          <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-sm bg-[#09090B]/70 text-[#FAFAFA] opacity-0 transition-opacity group-hover:opacity-100">
            <ArrowUpRight size={16} />
          </span>
        </div>
        <div className="p-5">
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-primary">
            {product.category}
          </span>
          <h3 className="mt-2 font-heading text-lg font-medium text-[#FAFAFA]">{product.name}</h3>
          <p className="mt-1 line-clamp-2 text-sm text-[#A1A1AA]">{product.tagline}</p>
          <div className="mt-4 flex items-center justify-between">
            <span className="font-mono text-base font-semibold text-[#FAFAFA]">
              €{from.toFixed(2)}
            </span>
            <span className="flex items-center gap-1 text-xs text-[#A1A1AA]">
              <Star size={13} className="fill-primary text-primary" /> {product.rating}
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
